const loadGoogleMapsApi = require('load-google-maps-api');

class Map {

    static loadGoogleMapsApi() {
        return loadGoogleMapsApi({
            key: "AIzaSyD5Zo4FCitnTgCGBvTBvzgj5lK87s07X1A"
        });
    }
    static createMap(googleMaps, mapElement) {
        var mapData = [{
            pos: {
                lat: 38.364531,
                lng: 140.381853,
            },
            zoom: 16
        }, {
            pos: {
                lat: 38.36801131824806,
                lng: 140.3896542364685,
            },
            zoom: 16
        }, ];

        //マーカー情報(情報ウインドウ含む)
        var markerData = [{
            pos: {
                lat: 38.364531,
                lng: 140.381853
            },
            title: "日東商事",
            icon: {
                url: "http://nitto-s.sakura.ne.jp/wp/wp-content/themes/nitto/img/ico_map.png",
                scaledSize: new google.maps.Size(60, 68)
            },
            infoWindowOpen: false
        }, {
            pos: {
                lat: 38.36801131824806,
                lng: 140.3896542364685,
            },
            title: "物流センター",
            icon: {
                url: "http://nitto-s.sakura.ne.jp/wp/wp-content/themes/nitto/img/ico_map02.png",
                scaledSize: new google.maps.Size(60, 68)
            },
            infoWindowOpen: false
        }, ];

        //地図の設定と作成
        let map = []
        markerData.forEach((marker, i) => {
            map[i] = new google.maps.Map(document.getElementById("map" + (i + 1)), {
                center: mapData[i].pos,
                zoom: mapData[i].zoom,
                mapTypeControl: false,
                panControl: false,
                scaleControl: false,
                streetViewControl: false,
                styles: [{
                        "featureType": "all",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                                "saturation": 36
                            },
                            {
                                "color": "#c3d2d5"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.stroke",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "color": "#1f3134"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.icon",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "saturation": "-100"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [{
                                "color": "#c3d2d5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [{
                                "color": "#c3d2d5"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#1f3134"
                            },
                            {
                                "lightness": "0"
                            },
                            {
                                "gamma": "1.00"
                            },
                            {
                                "saturation": "-30"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#c3d2d5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [{
                                "color": "#c3d2d5"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [{
                                "color": "#c3d2d5"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "saturation": "-100"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#c3d2d5"
                            },
                            {
                                "lightness": "-70"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "saturation": "-100"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#c3d2d5"
                            },
                            {
                                "lightness": "-70"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "saturation": "-100"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#000000"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#5a777c"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    }
                ]
            });
        })

        for (var i = 0; i < markerData.length; i++) {
            //即時関数
            (function () {
                //マーカーの設定と作成
                var marker = new google.maps.Marker({
                    position: markerData[i].pos,
                    title: markerData[i].title,
                    icon: markerData[i].icon,
                    map: map[i]
                });
                /*if( markerData[i].infoWindowContent )
                {
                    //情報ウインドウの設定と作成
                    var infoWindow = new google.maps.InfoWindow({
                        content: markerData[i].infoWindowContent
                    });
                    //情報ウインドウのオープンをマーカーのクリックイベントに登録
                    marker.addListener('click', function(){
                        infoWindow.open(map, marker);
                    });
                    //情報ウインドウのオープン
                    if( markerData[i].infoWindowOpen )
                    {
                        infoWindow.open(map, marker);
                    }
                }*/
            }());
        }
    }
}
export {
    Map
};